import React from "react";
import style from "../style/menu.module.css";
import { Link } from "react-router-dom";
import logo from "../img/logo2.png";

function Menu() {
  return (
    <header className={style.content}>
      <nav>
        <ul className={style.menu}>
          <li>
            <Link to="/" className={style.option}>
              <img src={logo} width={112} alt="Logo" />
            </Link>
          </li>

          <li>
            <Link to="/" className={style.option}>
              Tela de Início
            </Link>
          </li>

          <li>
            <Link to="/gasto" className={style.option}>
              Cadastrar Gasto
            </Link>
          </li>

          <li>
            <Link to="/receita" className={style.option}>
              Cadastrar Receita
            </Link>
          </li>

          <li>
            <Link to="/politica" className={style.option}>
              Privacidade e Termos
            </Link>
          </li>

          <li>
            <Link to= "/juntar" className={style.option}>
              Juntar Quanto
            </Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Menu;
